var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:{
    'pricing-tariffs-list': true,
    'pricing-tariffs-list--odd': _vm.currency !== 'rub' && _vm.currency !== 'kzt' && _vm.currency !== 'uzs',
    'pricing-tariffs-list--even': _vm.currency === 'rub' || _vm.currency === 'kzt' || _vm.currency === 'uzs',
  }},[_vm._l((_vm.tariffs),function(tariff){return [(
        tariff !== 'small' ||
        (tariff === 'small' && _vm.lang === 'ru' && (_vm.currency === 'rub' || _vm.currency === 'kzt' || _vm.currency === 'uzs'))
      )?_c('li',{staticClass:"pricing-tariffs-list__item"},[_c('PricingTariffsCard',{attrs:{"currency":_vm.currency,"lang":_vm.lang,"tariff":tariff}})],1):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }